export default __webpack_public_path__ + "static/media/gm-isb-girl.3e91a0f6.webp";